import { Modal } from 'antd';
import styled from 'styled-components';

export const PromoButton = styled.button`
  align-items: center;
  align-self: center;
  background: linear-gradient(120deg, ${p => p.theme.cDarkBlue}, ${p => p.theme.cIndigo});
  border: 1px solid rgba(255, 255, 255, .26);
  border-radius: 999px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(27, 83, 102, .22);
  color: ${p => p.theme.cWhite};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 9px;
  font-weight: 600;
  gap: 3px;
  grid-area: promo;
  justify-content: center;
  justify-self: center;
  min-width: 0;
  padding: 4px 5px;
  transition: box-shadow .2s ease, transform .2s ease, background .2s ease;
  white-space: nowrap;

  svg { color: #ffd15c; font-size: 1.1em; }

  &:hover,
  &:focus-visible {
    background: linear-gradient(120deg, #236b83, ${p => p.theme.cDarkBlue});
    box-shadow: 0 6px 16px rgba(27, 83, 102, .32);
    color: ${p => p.theme.cWhite};
    transform: translateY(-1px);
  }

  &:focus-visible { outline: ${p => p.theme.cBlue} 2px solid; outline-offset: 2px; }
  &:active { box-shadow: 0 2px 8px rgba(27, 83, 102, .24); transform: none; }

  @media (min-width: 351px) { font-size: 10px; gap: 4px; padding: 5px 7px; }

  @media (max-width: 400px) {
    border-radius: 50%;
    gap: 0;
    height: 30px;
    padding: 0;
    width: 30px;

    [data-full-label] { display: none; }
    svg { font-size: 15px; }
  }

  @media (min-width: 481px) { font-size: 12px; gap: 6px; padding: 6px 10px; }
  @media (min-width: ${p => p.theme.mobileLargeSize}) { font-size: 14px; line-height: 18px; padding: 8px 14px; }
`;

export const PromoModal = styled(Modal)`
  max-width: calc(100vw - 24px);

  .ant-modal-content {
    border-radius: 14px;
    max-height: calc(100vh - 24px);
    overflow: auto;
    padding: 0;
  }

  .ant-modal-header { border-bottom: 1px solid rgba(215, 216, 218, .51); margin: 0; padding: 16px 24px; }
  .ant-modal-body { padding: 18px 24px 22px; }
  .ant-modal-close { top: 12px; }

  @media (max-width: 576px) {
    .ant-modal-header { padding: 14px 18px; }
    .ant-modal-body { padding: 16px 18px 18px; }
  }
`;

export const PromoModalTitle = styled.span`
  align-items: center;
  color: ${p => p.theme.cDarkBlue};
  display: inline-flex;
  font-size: 18px;
  gap: 8px;

  svg { color: #e3a917; }
`;

export const PromoModalContent = styled.div`
  padding: 4px 0 8px;

  > strong {
    color: ${p => p.theme.cLinkLightBlue};
    display: block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .04em;
    margin-bottom: 6px;
    text-transform: uppercase;
  }

  > h2 {
    color: ${p => p.theme.cTextColor};
    font: 700 22px/1.2 ${p => p.theme.fontFamilyHeader};
    margin: 0 0 10px;
  }

  > p { color: ${p => p.theme.cDarkText}; font-size: 14px; line-height: 1.55; margin: 0; }
  > ul { display: flex; flex-direction: column; gap: 12px; list-style: none; margin: 20px 0 22px; padding: 0; }

  > ul li {
    align-items: flex-start;
    color: ${p => p.theme.cTextColor};
    display: flex;
    font-size: 14px;
    gap: 10px;
    line-height: 1.45;
  }

  > ul li > span:first-child {
    align-items: center;
    background: rgba(5, 176, 240, .12);
    border-radius: 50%;
    color: ${p => p.theme.cLinkLightBlue};
    display: inline-flex;
    flex: 0 0 24px;
    height: 24px;
    justify-content: center;
    margin-top: -1px;
    width: 24px;
  }

  > small { color: ${p => p.theme.cGreyText}; display: block; font-size: 12px; line-height: 1.4; margin-top: 10px; text-align: center; }

  @media (min-width: ${p => p.theme.mobileLargeSize}) {
    > h2 { font-size: 25px; }
  }
`;
